import { SDK_KIND } from "../../constants/index.js";
import { useAccountStore, useBaseAppDevStore } from "../stores/index.js";
import { WorkerHandler } from "./../kf_sdk/sdk.handler.js";
import { isMobile } from "./../kf_sdk/utils.js";

export async function SDKExecutor({ code, options, args, context }) {
  // eslint-disable-next-line no-undef
  const workerPath = `/static/base/${PLATFORM_TYPE}/${window.dependent_versionNumber.base}/sandbox/worker.js`;

  const accountDetails = await useAccountStore.getState().getAccountDetails();
  const { Name, Email, _id, status: userStatus } = accountDetails.UserDetails;
  const { currentRoles, pageId } = useBaseAppDevStore.getState().context;
  let currentAppId = useBaseAppDevStore.getState().currentAppId;
  let executionContext = {
    ...context,
    envDetails: {
      isMobile: isMobile()
    },
    user: {},
    account: { _id: accountDetails._id }
  };
  executionContext["kind"] = currentAppId ? SDK_KIND.LOWCODE : SDK_KIND.NOCODE;
  if (!context.appId) {
    executionContext["appId"] = currentAppId;
  }
  if (!context.pageId) {
    executionContext["pageId"] = pageId;
  }
  if (userStatus !== "error") {
    // userStatus will be error for public forms
    executionContext["user"] = {
      _id,
      Name,
      Email,
      Role: {
        _id: currentRoles[0]?._id,
        Name: currentRoles[0]?.Name
      },
      AppRoles: currentRoles.map((role) => ({
        _id: role._id,
        Name: role.Name
      }))
    };
  }

  const storeInstanceId =
    context?.tableId ||
    context?.formInstanceId ||
    context?.componentId ||
    pageId;

  const prevWorkerInstance = useBaseAppDevStore
    .getState()
    .getWorkerInstance(storeInstanceId);

  prevWorkerInstance && prevWorkerInstance.terminateWorker();

  const workerInstance = new WorkerHandler(workerPath);
  useBaseAppDevStore
    .getState()
    .setWorkerInstance(storeInstanceId, workerInstance);

  const resolve = await workerInstance.executeCode({
    code,
    options: options || {},
    args: args || {},
    context: executionContext
  });
  return resolve;
}
